wp.domReady( () => {

	/**
	 * Unregister default Button styles
	 */
	wp.blocks.unregisterBlockStyle( 'core/button', 'outline' );
	wp.blocks.unregisterBlockStyle( 'core/button', 'fill' );

	/**
	 * Add custom styles to Button block
	 */
	wp.blocks.registerBlockStyle( 'core/button', [
		{
			name: 'primary',
			label: 'Primary',
			isDefault: true,
		},
		{
			name: 'black-border',
			label: 'Black border',
		},
	] );


	/**
	 * Add custom styles to List block
	 */
	wp.blocks.registerBlockStyle( 'core/list', [
		{
			name: 'primary',
			label: 'Primary (default)',
			isDefault: true,
		},
		{
			name: 'group',
			label: 'Group',
		},
	] );

	/**
	 * Add custom styles to List block
	 */
	wp.blocks.registerBlockStyle( 'core/list-item', [
		{
			name: 'primary',
			label: 'Primary (default)',
			isDefault: true,
		},
		{
			name: 'secondary',
			label: 'Secondary',
		},
		{
			name: 'white',
			label: 'White',
		},
		{
			name: 'with-arrow',
			label: 'With arrow',
		},
	] );

	/**
	 * Query loop
	 */

	wp.blocks.registerBlockStyle( 'core/query', [
		{
			name: 'default',
			label: 'Default',
		},
		{
			name: 'smoobu',
			label: 'Smoobu',
			isDefault: true,
		}
	] );

	wp.blocks.registerBlockStyle( 'core/post-excerpt', [
		{
			name: 'no-link',
			label: 'Without read more',
		},
	] );

	wp.blocks.registerBlockStyle( 'core/post-author', [
		{
			name: 'rounded',
			label: 'Rounded avatar',
		},
	] );

	wp.blocks.unregisterBlockStyle( 'core/image', 'rounded' );
	wp.blocks.unregisterBlockStyle( 'core/image', 'default' );

	/**
	 * Post terms
	 */

	wp.blocks.registerBlockStyle( 'core/post-terms', [
		{
			name: 'gray-button',
			label: 'Gray button',
		}
	] );


} );
